import React from 'react'
import bannerImg from "../assets/images/banner-img.png"
import Svg from '../common/Svg'

export default function QNA() {
    return (
        <>
            <div className='banner-section-qna bg-img new-banner'>
                <div className="container">
                    <div className="row">
                        <div className='col-lg-8 d-flex align-items-center'>
                            <div className="left-logo">
                                <Svg name="vodafone-logo-small" />
                            </div>
                            <div className="text-wrap flex-grow-1">
                                {/* <div className="logo-wrap">
                                    <Svg name="vodafone-logo" />
                                </div> */}
                                {/* <p><strong>Vodafone</strong> Business</p> */}
                                <h1>Vodafone Business<br /> Rapid Cloud Assessment</h1>
                            </div>
                        </div>
                        {/* <div className='col-md-4 col-lg-5 image-cen'>
                            <div className="img-wrap">
                                <img src={bannerImg} alt='bannerImg' className='img-fluid' />
                            </div>
                        </div> */}
                    </div>

                </div>
            </div>
            <div className="qna-section-wrap">
                <div className="qna-progress">
                    <div className="container">
                        <div className="prograss-wrap ">
                            <div className="prograss-bg">
                                <div className="prograss-active group-1" style={{ width: '20%' }} />
                                <div className="prograss-active group-1" style={{ width: '20%' }} />
                                <div className="prograss-active group-1" style={{ width: '0%' }} />
                                <div className="prograss-active group-1" style={{ width: '0%' }} />
                                <div className="prograss-active group-1" style={{ width: '0%' }} />
                            </div>
                            <div className="prograss-listing">
                                <ul>
                                    <li className="in-progress group-1">
                                        <div className="text-wrap">Business</div>
                                    </li>
                                    <li className=" group-2">
                                        <div className="text-wrap">People</div>
                                    </li>
                                    <li className="group-3">
                                        <div className="text-wrap">Operating Model</div>
                                    </li>
                                    <li className="group-4">
                                        <div className="text-wrap">Infrastructure</div>
                                    </li>
                                    <li className="group-5">
                                        <div className="text-wrap">Network</div>
                                    </li>
                                    <li className="group-6">
                                        <div className="text-wrap">Security</div>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="questions-wrapper">
                    <div className="container">
                        <div className="question-list">
                            <div className="section-heading">
                                <h3>Business</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer mollis porttitor diam, sed consequat ligula feugiat quis. Integer enim sem</p>
                            </div>

                            <div className="question-inner question-wrap question-type-radio error">
                                <div className="custom-tooltip-wrap">
                                    <div className="icon-wrap">
                                        <Svg name="info-icon" />
                                    </div>
                                    <div className="text-wrap">
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec eget augue ac sapien venenatis fringilla. Pellentesque congue imperdiet tortor nec maximus.</p>
                                    </div>
                                </div>
                                <div className="heading" question-count={1}>Are you looking to move to the cloud due to external factors? (i.e. Contract
                                    renewal, business move. business growth)
                                </div>
                                <div className="answer-options answerOptions-wrap bark-color">
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus1_ans" type="radio" id="qus1_ans1" data-score={10} defaultValue="a" autoComplete="new-input" />
                                        <label className="form-check-label" htmlFor="qus1_ans1">
                                            <span>Yes</span>
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus1_ans" type="radio" id="qus1_ans2" data-score={20} defaultValue="b" autoComplete="new-input" />
                                        <label className="form-check-label" htmlFor="qus1_ans2">
                                            <span>No</span>
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus1_ans" type="radio" id="qus1_ans3" data-score={30} defaultValue="c" autoComplete="new-input" />
                                        <label className="form-check-label" htmlFor="qus1_ans3">
                                            <span>Don't Know</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="error-message">
                                    <Svg name="error-icon" />
                                    <p>Please select an answer for this question to continue</p>
                                </div>
                            </div>

                            <div className="question-inner question-wrap question-type-radio">
                                <div className="heading" question-count={2}>How far are you in creating a cloud strategy?</div>
                                <div className="answer-options answerOptions-wrap bark-color">
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus2_ans" type="radio" id="qus2_ans1" data-score={10} defaultValue="a" autoComplete="new-input" />
                                        <label className="form-check-label" htmlFor="qus2_ans1">
                                            <span>No strategy developed as yet.</span>
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus2_ans" type="radio" id="qus2_ans2" data-score={20} defaultValue="b" autoComplete="new-input" />
                                        <label className="form-check-label" htmlFor="qus2_ans2">
                                            <span>Discussions have taken place, but no formal strategy noted down.</span>
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus2_ans" type="radio" id="qus2_ans3" data-score={30} defaultValue="c" autoComplete="new-input" />
                                        <label className="form-check-label" htmlFor="qus2_ans3">
                                            <span>Some items have been created, but still have some unanswered questions.</span>
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus2_ans" type="radio" id="qus2_ans4" data-score={30} defaultValue="d" autoComplete="new-input" />
                                        <label className="form-check-label" htmlFor="qus2_ans4">
                                            <span>Some items have been created, but still have some unanswered questions.</span>
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus2_ans" type="radio" id="qus2_ans5" data-score={30} defaultValue="e" autoComplete="new-input" />
                                        <label className="form-check-label" htmlFor="qus2_ans5">
                                            <span>Full Strategy defined, written, confirmed and presented internally.</span>
                                        </label>
                                    </div>

                                </div>
                            </div>

                            <div className="question-inner question-wrap question-type-radio">
                                <div className="heading" question-count={3}>Is your business looking to modernise the product set/infrastructure when moving to the cloud? (i.e. moving from Virtual Machines to Containers)</div>
                                <div className="answer-options answerOptions-wrap bark-color">
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus3_ans" type="radio" id="qus3_ans1" data-score={10} defaultValue="a" autoComplete="new-input" />
                                        <label className="form-check-label" htmlFor="qus3_ans1">
                                            <span>Yes</span>
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus3_ans" type="radio" id="qus3_ans2" data-score={20} defaultValue="b" autoComplete="new-input" />
                                        <label className="form-check-label" htmlFor="qus3_ans2">
                                            <span>No</span>
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus3_ans" type="radio" id="qus3_ans3" data-score={30} defaultValue="c" autoComplete="new-input" />
                                        <label className="form-check-label" htmlFor="qus3_ans3">
                                            <span>Don't Know</span>
                                        </label>
                                    </div>
                                </div>
                            </div>


                            <div className="question-inner question-wrap question-type-checkbox">
                                <div className="heading" question-count={4}>Which of these last mile technologies are you using or planning to use?
                                </div>
                                <div className="answer-options answerOptions-wrap bark-color">
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus4_ans" type="checkbox" id="qus4_ans1" />
                                        <label className="form-check-label" htmlFor="qus4_ans1">
                                            Transportation Management System (TMS)
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus4_ans" type="checkbox" id="qus4_ans2" />
                                        <label className="form-check-label" htmlFor="qus4_ans2">
                                            Order Management System (OMS)
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus4_ans" type="checkbox" id="qus4_ans3" />
                                        <label className="form-check-label" htmlFor="qus4_ans3">
                                            Fleet Management System (FMS)
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus4_ans" type="checkbox" id="qus4_ans4" />
                                        <label className="form-check-label" htmlFor="qus4_ans4">
                                            Route Planning Software
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus4_ans" type="checkbox" id="qus4_ans5" />
                                        <label className="form-check-label" htmlFor="qus4_ans5">
                                            Microsoft Excel
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus4_ans" type="checkbox" id="qus4_ans6" />
                                        <label className="form-check-label" htmlFor="qus4_ans6">
                                            We plan our last mile manually
                                        </label>
                                    </div>
                                </div>
                            </div>


                            <div className="question-inner question-wrap question-type-checkbox">
                                <div className="heading" question-count={4}>Which of these last mile technologies are you using or planning to use?
                                </div>
                                <div className="answer-options answerOptions-wrap bark-color">
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus4_ans" type="checkbox" id="qus4_ans1" />
                                        <label className="form-check-label" htmlFor="qus4_ans1">
                                            Transportation Management System (TMS)
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus4_ans" type="checkbox" id="qus4_ans2" />
                                        <label className="form-check-label" htmlFor="qus4_ans2">
                                            Order Management System (OMS)
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus4_ans" type="checkbox" id="qus4_ans3" />
                                        <label className="form-check-label" htmlFor="qus4_ans3">
                                            Fleet Management System (FMS)
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus4_ans" type="checkbox" id="qus4_ans4" />
                                        <label className="form-check-label" htmlFor="qus4_ans4">
                                            Route Planning Software
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus4_ans" type="checkbox" id="qus4_ans5" />
                                        <label className="form-check-label" htmlFor="qus4_ans5">
                                            Microsoft Excel
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" name="qus4_ans" type="checkbox" id="qus4_ans6" />
                                        <label className="form-check-label" htmlFor="qus4_ans6">
                                            We plan our last mile manually
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="question-inner question-wrap question-type-checkbox">
                                <div className="heading" question-count={5}>
                                    How satisfied are your customers with the updates they receive on their order status?
                                </div>

                                <div className="answer-options answerOptions-wrap">
                                    <div className="icon-counter icon-counter-progress number-counter">
                                        <div className="prograss-bg">
                                            <div className="prograss-active" style={{ width: '0%' }} />
                                        </div>
                                        <div className="icon-counter-wrapper text-center">
                                            <input name="qus5_ans" type="radio" id="qus5_ans1" />
                                            <label htmlFor="qus5_ans1" className="text-wrap active">
                                                <div className="couter-wrap">
                                                    <Svg name="smily-1" />
                                                </div>
                                                <div className="text">
                                                    <span>Very satisfied</span>
                                                </div>
                                            </label>
                                        </div>
                                        <div className="icon-counter-wrapper text-center">
                                            <input name="qus5_ans" type="radio" id="qus5_ans2" />
                                            <label htmlFor="qus5_ans2" className="text-wrap">
                                                <div className="couter-wrap">
                                                    <Svg name="smily-2" />
                                                </div>
                                                <div className="text"><span>Somewhat satisfied</span></div>
                                            </label>
                                        </div>
                                        <div className="icon-counter-wrapper text-center">
                                            <input name="qus5_ans" type="radio" id="qus5_ans3" />
                                            <label htmlFor="qus5_ans3" className="text-wrap">
                                                <div className="couter-wrap">
                                                    <Svg name="smily-3" />
                                                </div>
                                                <div className="text"><span>Not sure</span></div>
                                            </label>
                                        </div>
                                        <div className="icon-counter-wrapper text-center">
                                            <input name="qus5_ans" type="radio" id="qus5_ans4" />
                                            <label htmlFor="qus5_ans4" className="text-wrap">
                                                <div className="couter-wrap">
                                                    <Svg name="smily-4" />
                                                </div>
                                                <div className="text"><span>Not satisfied</span></div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="btn-wrapper d-flex align-items-center">
                            <button className='btn btn-link btn-icon'>
                                <Svg name="back-button-icon" /> Back
                            </button>
                            <button className='btn btn-primary btn-icon ms-auto'>
                                Next <Svg name="button-icon" />
                            </button>
                        </div>

                        {/* <div className="btn-wrapper text-center">
                            <button className='btn btn-primary btn-icon mx-auto'>
                                Submit <Svg name="button-icon" />
                            </button>
                        </div> */}
                    </div>
                </div>
            </div>

        </>
    )
}
